import { InherentRiskGroup } from '@/gen/inventory/v1/company_service_pb'

export const STEP_KIND = {
  OVERVIEW: 'overview',
  QUESTION: 'question',
  ASSIGN: 'assign',
} as const

export type SidebarStep =
  | { kind: typeof STEP_KIND.OVERVIEW }
  | { kind: typeof STEP_KIND.QUESTION; group: InherentRiskGroup; isActive: boolean }
  | { kind: typeof STEP_KIND.ASSIGN }

export type SidebarRenderItem =
  | { kind: typeof STEP_KIND.OVERVIEW; index: number }
  | { kind: typeof STEP_KIND.ASSIGN; index: number }
  | { kind: 'category-header'; category: string }
  | { kind: typeof STEP_KIND.QUESTION; group: InherentRiskGroup; index: number; isActive: boolean }
  | { kind: 'separator' }

// A conditional question whose condition is not met renders as 'conditional': shown but disabled.
export type SidebarItemState = 'active' | 'visited' | 'idle' | 'conditional'
